/*
 * Copyright (c) 2016-2019 Martin Donath <martin.donath@squidfunk.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */

import Listener from "./Listener" // eslint-disable-line no-unused-vars

/* ----------------------------------------------------------------------------
 * Class
 * ------------------------------------------------------------------------- */

export default class MatchMedia {

  /**
   * Media query listener
   *
   * This class listens for state changes of media queries and automatically
   * switches the given listeners on or off.
   *
   * @constructor
   *
   * @property {Function} handler_ - Media query event handler
   *
   * @param {string} query - Media query to test for
   * @param {Listener} listener - Event listener
   */
  constructor(query, listener) {
    this.handler_ = mq => {
      if (mq.matches)
        listener.listen()
      else
        listener.unlisten()
    }

    /* Initialize media query listener */
    const media = window.matchMedia(query)
    media.addListener(this.handler_)

    /* Always check at initialization */
    this.handler_(media)
  }
}
